import sectionMarqueeBasicTextCss from '../css-snippets/section-marquee-basic-text';

const html = `
<style>${sectionMarqueeBasicTextCss}</style>
<div class="marquee-basic-text-wrapper" data-attribute="marquee-basic-text-container" data-background="#17d4f4" data-color="#ffffff" style="background-color: #17d4f4; color: #ffffff;">
  <marquee onmouseover="stop()" onmouseout="start()">
    <div data-attribute="grid-group" class="grid-group">
      ${Array(30)
        .fill(
          `<div data-attribute="wrap-item" class="wrap-item">
                <div data-attribute="item-text" class="item-text">
                🎁 30-Day Money Back Guarantee
                </div>
            </div>`,
        )
        .join('')}
    </div>
  </marquee>
</div>
`;
export default html;
